const colLinks: { title: string; links: { label: string; href: string }[] }[] = [
  {
    title: "栏目直达",
    links: [
      { label: "在追专题", href: "#topics" },
      { label: "热度飙升", href: "#heat" },
      { label: "发酵追踪", href: "#track" },
      { label: "讨论区", href: "#community" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "关于黑料", href: "#top" },
      { label: "爆料投稿", href: "#community" },
      { label: "转载与合作", href: "#top" },
      { label: "联系方式", href: "#top" },
    ],
  },
];

export default function FooterBand() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-12">
          <div className="lg:col-span-6">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="relative grid h-9 w-9 place-items-center bg-background-100 text-foreground-950">
                <span className="font-heading text-lg font-black leading-none">黑</span>
                <span className="absolute -right-1.5 -top-1.5 h-2.5 w-2.5 bg-primary-500" />
              </span>
              <span className="font-heading text-2xl font-black tracking-tight text-background-50">黑料</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-7 text-background-100/60">
              专注「事件后续怎么发展」的发酵追踪站。最新进展、后续爆料、当事人回应动态与热度排名，一个入口随时跟进。
            </p>
            <div className="mt-5 flex gap-2.5">
              {["ri-weibo-fill", "ri-wechat-fill", "ri-tiktok-line", "ri-rss-fill"].map((i) => (
                <a
                  key={i}
                  href="#top"
                  aria-label="社交"
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-background-700 text-background-100/70 transition-colors hover:border-accent-400 hover:text-accent-300"
                >
                  <i className={`${i} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {colLinks.map((c) => (
            <div key={c.title} className="lg:col-span-2">
              <p className="mb-3 text-xs font-bold tracking-widest text-background-100/50">{c.title}</p>
              <ul className="space-y-2.5">
                {c.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      rel="nofollow"
                      className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm text-background-100/75 transition-colors hover:text-accent-400"
                    >
                      <i className="ri-arrow-right-s-line text-accent-500/60" />
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-2">
            <p className="mb-3 text-xs font-bold tracking-widest text-background-100/50">追更提醒</p>
            <p className="text-sm leading-6 text-background-100/60">
              想不错过任何反转瞬间？
              <br />
              认准黑料，随时回来看看。
            </p>
            <a
              href="#heat"
              className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-3.5 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              看热度榜
              <i className="ri-arrow-right-line text-sm" />
            </a>
          </div>
        </div>

        <div className="mt-10 rounded-lg border border-dashed border-background-700/70 bg-background-900/60 px-4 py-3 text-xs leading-6 text-background-100/60">
          <span className="font-semibold text-background-100/80">内容声明 · </span>
          本站为虚构内容演示站点，所有事件、人物、录音、言论与数据均为编辑部虚构编排，仅用于呈现信息版式与「发酵追踪」产品逻辑，不构成对任何真实个体、团体或机构的评价与指认。如需真实资讯请以官方与权威信源为准。
        </div>

        <div className="mt-6 flex flex-col items-start justify-between gap-3 border-t border-background-700/60 pt-5 text-xs text-background-100/50 sm:flex-row sm:items-center">
          <p>© 2026 黑料 · 八卦发酵追踪站 · 全程跟进 不落一个反转</p>
          <p className="flex items-center gap-2">
            <i className="ri-shield-check-line text-accent-500/70" />
            仅作阅读演示 · 不采集不存储任何个人信息
          </p>
        </div>
      </div>
    </footer>
  );
}